var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.5C1.55109 2.5 1.36032 2.42098 1.21967 2.28033C1.07902 2.13968 1 1.94891 1 1.75C1 1.55109 1.07902 1.36032 1.21967 1.21967C1.36032 1.07902 1.55109 1 1.75 1C1.94891 1 2.13968 1.07902 2.28033 1.21967C2.42098 1.36032 2.5 1.55109 2.5 1.75C2.5 1.94891 2.42098 2.13968 2.28033 2.28033C2.13968 2.42098 1.94891 2.5 1.75 2.5ZM1.75 8.5C1.55109 8.5 1.36032 8.42098 1.21967 8.28033C1.07902 8.13968 1 7.94891 1 7.75C1 7.55109 1.07902 7.36032 1.21967 7.21967C1.36032 7.07902 1.55109 7 1.75 7C1.94891 7 2.13968 7.07902 2.28033 7.21967C2.42098 7.36032 2.5 7.55109 2.5 7.75C2.5 7.94891 2.42098 8.13968 2.28033 8.28033C2.13968 8.42098 1.94891 8.5 1.75 8.5ZM1.75 14.5C1.55109 14.5 1.36032 14.421 1.21967 14.2803C1.07902 14.1397 1 13.9489 1 13.75C1 13.5511 1.07902 13.3603 1.21967 13.2197C1.36032 13.079 1.55109 13 1.75 13C1.94891 13 2.13968 13.079 2.28033 13.2197C2.42098 13.3603 2.5 13.5511 2.5 13.75C2.5 13.9489 2.42098 14.1397 2.28033 14.2803C2.13968 14.421 1.94891 14.5 1.75 14.5Z",
    stroke: "#474F63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.5f0b862bb42c811d34362ca9ca6ba633.svg";
export { ForwardRef as ReactComponent };